export default "__VITE_ASSET__2BfKqhlD__"